  

      <div class ="design-container" id="expanded-container">
        <div class="tool-chunk" >

          <button 
          mat-icon-button
          color="white" 
          (click)="closeDetailView()">
          <i class="fas fa-window-close"></i>
          </button>


          <!-- <h1>viewing detail for: {{draftname}}</h1> -->
  
  
      </div>
  

      <div class="viewers">


        <app-draftviewer 
        id="draft_viewer"
        [id]="id"
        [class.expanded]="viewer_expanded"
        source = "weaver"
        (onNewSelection) = "updateSelection($event)"
        (onDrawdownUpdated)="drawdownUpdated()"
        (onLoomSettingsUpdated)="loomSettingsUpdated()"
        (onMaterialChange)="materialChange()"
        (onViewerExpanded)="expandViewer()">
        </app-draftviewer>

        

        <app-simulation id="sim_viewer" style= 'width: 50%'
        [id]="id"
        (onExpanded)="expandSimulation()"
        >
        </app-simulation>
      </div>



  
 

   </div>
